// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2675":"94344abd","3872":"94344abd","5841":"94344abd"}[chunkId] + ".chunk.css";
};